import { useEffect, useEffectEvent } from 'react';

import { type AppEventMap, appEvents } from './index';

export function useEvent<K extends keyof AppEventMap>(
  event: K,
  handler: (payload: AppEventMap[K]) => void
): void {
  const onEvent = useEffectEvent(handler);
  useEffect(() => appEvents.on(event, onEvent), [event]);
}
